<template>
    <section class="hero">

        <b-loading v-if="loading" :active="true" :can-cancel="false"></b-loading>

        <div class="hero-body" v-if="displayForm">

            <div class="container">

                <div class="column is-6 is-offset-3">

                    <div class="box" style="margin-top:10vh;">

                        <div class="header">

                            <h1>STORMPORT</h1>

                            <p>SIGN UP</p>

                        </div>

                        <form>

                            <b-field label="Firm Name">

                                <b-autocomplete v-model="form.firmName" :keep-first="keepFirst" :data="filteredDataObj"
                                    field="name" size="is-large"> </b-autocomplete>

                            </b-field>

                            <b-field label="Person Name">

                                <b-input v-model="form.personName" size="is-large"></b-input>

                            </b-field>

                            <b-field label="Mobile">

                                <b-input v-model="form.mobile" size="is-large"></b-input>

                            </b-field>

                            <b-field label="Email">

                                <b-input v-model="form.email" size="is-large"></b-input>

                            </b-field>

                            <b-field label="Password">

                                <b-input type="password" v-model="form.password" size="is-large"></b-input>

                            </b-field>

                            <b-field label="Confirm Password">

                                <b-input type="password" v-model="form.password_confirmation" size="is-large"></b-input>

                            </b-field>

                            <hr>

                            <div class="buttons">

                                <button class="button is-block is-info is-large is-fullwidth" @click.prevent="submit">Create
                                    Account</button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>

import { AuthService } from "@/services/auth.service.js";

import { FirmService } from "@/services/firm.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

import { startRouteMixin } from "@/mixins/startRouteMixin";

export default {

    mixins: [startRouteMixin],

    data: function () {

        return {

            loading: false,

            firms: [],

            keepFirst: false,

            openOnFocus: false,

            selected: null,

            displayForm: false,

            form: {

                firmName: '',

                personName: '',

                mobile: '',

                email: '',

                password: '',

                password_confirmation: '',

            }

        }
    },

    computed: {

        filteredDataObj() {

            return this.firms.filter((element) => {

                return element.name.toLowerCase().indexOf(this.form.firmName.toLowerCase()) >= 0

            })
        }

    },

    methods: {

        fetchFirmsAll() {

            return FirmService.getPublicAll({ archived: 0 }).then(response => {

                this.firms = JsonDenormalizer.denormalize(response);


            });

        },

        submit() {

            this.loading = true;

            AuthService.register(this.form).then(response => {

                if (response.token) {

                    this.$store.dispatch("Auth/setToken", response.token);

                    this.navigateToStartRoute();

                } else {

                    this.loading = false;

                    this.$buefy.toast.open({

                        message: 'Failed to login',

                        type: "is-danger",

                        position: "is-top-right"

                    });
                }

            }).catch(error => {

                this.loading = false;

            });

        },

        isLoggedin() {

            if (this.$store.state.Auth.token) {

                this.navigateToStartRoute();

            } else {

                this.displayForm = true;

            }

        }

    },

    created() {

        this.isLoggedin();

    },

    mounted() {

        this.fetchFirmsAll();

    }

};

</script>

<style scoped>
.header {

    /*font-family: 'Roboto', sans-serif !important;*/

    margin-bottom: 15px;

    font-weight: bold !important;

    padding: 15px 0px;
}

.header h1 {

    font-size: 30px;

    font-weight: bold !important;
}

.header p {

    font-size: 18px;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/Signup/index.vue